// Eduphoria Aware "Export View" workbook: row 1 carries the test name merged across each
// test's column block, row 2 carries the real headers (Student Name, Local ID, demographics,
// then Raw Score / Percent Score / ... / Date Taken per test). Detected as an Interim so the
// existing interim upload form (name, date, cut-points year) and server rail handle it.

// cell.text throws on merged cells whose master value is null, so derive text from cell.value.
const cellText = (cell) => {
  const value = cell ? cell.value : null;
  if (value == null) {
    return '';
  }
  if (typeof value === 'object') {
    if (Array.isArray(value.richText)) {
      return value.richText.map((part) => part.text).join('');
    }
    if (value.text != null) {
      return String(value.text);
    }
    return '';
  }
  return String(value);
};

const isEduphoriaAware = (file) =>
  new Promise((resolve) => {
    const isXlsxFile =
      file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
      (file.name || '').toLowerCase().endsWith('.xlsx');
    if (!isXlsxFile) {
      resolve(false);
      return;
    }
    const reader = new FileReader();
    reader.onerror = () => resolve(false);
    reader.onload = async () => {
      try {
        const exceljsModule = await import('exceljs/dist/exceljs.min.js');
        const ExcelJS = exceljsModule.default || exceljsModule;
        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(reader.result);
        const sheet = workbook.worksheets[0];
        if (!sheet) {
          resolve(false);
          return;
        }
        const titleRow = sheet.getRow(1);
        const headerRow = sheet.getRow(2);
        let hasStudentName = false;
        let hasLocalId = false;
        let hasTitledPercentScore = false;
        for (let col = 1; col <= sheet.columnCount; col += 1) {
          const header = cellText(headerRow.getCell(col)).trim();
          if (header === 'Student Name') {
            hasStudentName = true;
          }
          if (header === 'Local ID') {
            hasLocalId = true;
          }
          if (header === 'Percent Score' && cellText(titleRow.getCell(col)).trim()) {
            hasTitledPercentScore = true;
          }
        }
        resolve(hasStudentName && hasLocalId && hasTitledPercentScore);
      } catch (error) {
        resolve(false);
      }
    };
    reader.readAsArrayBuffer(file);
  });

export default isEduphoriaAware;
